var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.image},on:{"error":function($event){_vm.error = true},"load":_vm.loadHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }